import OnboardingSlide from './OnboardingSlide';
import PatientsDemoAnimation from './PatientsDemoAnimation';

export default function SlidePatients() {
  return (
    <OnboardingSlide illustration={<PatientsDemoAnimation />} title="Your Patients">
      <p>
        This is the <strong>Patients</strong> page — your home screen for the shift. Here you see
        everyone assigned to you.
      </p>
      <ul className="list-inside list-disc space-y-1 text-xs">
        <li>
          <strong>Favorite</strong> patients with the star so they stay at the top of your list.
        </li>
        <li>
          <strong>Tap a patient</strong> to view their tasks, allergies, age, diagnoses, and more.
        </li>
        <li>Overdue task counts appear on the card so you know who needs attention.</li>
        <li>Filter by ward or search by name or room number.</li>
      </ul>
      <p className="text-xs text-gray-500">
        Start your shift from the banner at the top before documenting.
      </p>
    </OnboardingSlide>
  );
}
